"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSensitiveFields = void 0;
exports.beforeSend = beforeSend;
const Log = __importStar(require("./Log"));
const FILTERED_FIELD_PLACEHOLDER = "[Filtered in client]";
/**
 * A list of fields/property names that are known to contain potentially
 * personally identifiable information (PII).
 * This list is taken from Fleming.client implementation https://github.com/Accurx/rosemary/blob/trunk/src/Web/accuRx.Fleming.Client/ClientApp/src/SentryFilters.ts
 * and supplemented with data from Florey.
 */
exports.defaultSensitiveFields = [
    "nhsnumber",
    "dob",
    "date",
    "dateofbirth",
    "email",
    "name",
    "given",
    "fullname",
    "firstname",
    "surname",
    "familyname",
    "address",
    "postcode",
    "phone",
    "mobile",
    "forename",
    "gender",
    "number",
];
/**
 * Method recursievly replace sensetive fields values with placeholder
 * Boolean fields are left as is.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const filterData = (data, sensitiveFieldsRegex) => {
    if (!data)
        return;
    for (const key in data) {
        if (typeof data[key] === 'boolean') {
            continue;
        }
        if (data[key] && typeof data[key] === "object" && data[key].constructor === Object) {
            filterData(data[key], sensitiveFieldsRegex);
            continue;
        }
        if (sensitiveFieldsRegex.test(key.toLowerCase())) {
            data[key] = FILTERED_FIELD_PLACEHOLDER;
        }
    }
};
/**
 * Basic data scrubbing on the event before it is sent to Sentry.
 * Fleming.client implementation https://github.com/Accurx/rosemary/blob/trunk/src/Web/accuRx.Fleming.Client/ClientApp/src/SentryFilters.ts was taken
 * Deep check was added for breadcrumbs as they may contain more complex data structure.
 * Boolean fields are left as is
 */
function scrubSensitiveData({ event, sensitiveFields = [], }) {
    var _a;
    const fieldsToBeScrubbed = sensitiveFields.concat(exports.defaultSensitiveFields);
    const uniqueFieldNames = Array.from(new Set(fieldsToBeScrubbed));
    const sensitiveFieldsRegex = new RegExp(uniqueFieldNames.join("|"), "i");
    for (const key in event.tags) {
        if (sensitiveFieldsRegex.test(key.toLowerCase())
            && typeof event.tags[key] !== 'boolean') {
            event.tags[key] = FILTERED_FIELD_PLACEHOLDER;
        }
        // explicitly check api.query tag *value*, as it could be a list of
        // arbitrary key-value pairs
        if (key === "api.query") {
            const tagValue = ((_a = event.tags[key]) === null || _a === void 0 ? void 0 : _a.toString()) || "";
            const match = sensitiveFieldsRegex.test(tagValue);
            if (match === true) {
                event.tags[key] = FILTERED_FIELD_PLACEHOLDER;
            }
        }
    }
    for (const key in event.extra) {
        if (sensitiveFieldsRegex.test(key.toLowerCase())
            && typeof event.extra[key] !== 'boolean') {
            event.extra[key] = FILTERED_FIELD_PLACEHOLDER;
        }
    }
    if (event.breadcrumbs) {
        event.breadcrumbs.forEach((breadcrumb) => {
            filterData(breadcrumb.data, sensitiveFieldsRegex);
        });
    }
    for (const contextName in event.contexts) {
        const context = event.contexts[contextName];
        for (const key in context) {
            if (sensitiveFieldsRegex.test(key.toLowerCase())) {
                context[key] = FILTERED_FIELD_PLACEHOLDER;
            }
        }
    }
    return event;
}
/**
 * Returns true, if this is an error we don't want to reach Sentry
 */
const isSpuriousError = (event, hint) => {
    if (hint &&
        hint.originalException &&
        hint.originalException instanceof Error &&
        hint.originalException.name === 'UnhandledRejection' &&
        hint.originalException.message.indexOf('Object Not Found Matching Id') === 0) {
        // This seems to be a spurious error caused by a password manager.  See
        // https://github.com/getsentry/sentry-javascript/issues/3440
        Log.info('Suppress Object Not Found Matching Id, probable password manager');
        return true;
    }
    else if (hint &&
        hint.originalException &&
        hint.originalException instanceof Error &&
        hint.originalException.message
            .toLowerCase()
            .includes("user is not logged in")) {
        // Keep in sync with `useCurrentUser` hook in Fleming
        return true;
    }
    return false;
};
/**
 * Handles any processing we want to do before sending events to Sentry, specifically at the moment
 * this is removing any spurious logs, and scrubbing any sensitive data from the logs
 */
function beforeSend({ event, hint, sensitiveFields = [], }) {
    if (isSpuriousError(event, hint)) {
        return null;
    }
    // Important: We should always do the scrubbing sensitive data as the last operation
    // to ensure all sensitive data is scrub
    return scrubSensitiveData({ event, sensitiveFields });
}
//# sourceMappingURL=SentryFilters.js.map